export class ICSMessage {
  constructor(
    public subject = '',
    public to = {
      name: '',
      email: '',
    },
    public htmlContent = {}
  ) {}

  private generateICSData() {
    return [
      `BEGIN:VCALENDAR`,
      `PRODID:-//Microsoft Corporation//Outlook 16.0 MIMEDIR//EN`,
      `VERSION:2.0`,
      `X-MS-OLK-FORCEINSPECTOROPEN:TRUE`,
      `BEGIN:VEVENT`,
      `ATTENDEE;CN="${this.to.email}";RSVP=TRUE:mailto:${this.to.email}`,
      `CLASS:PUBLIC`,
      `SUMMARY;LANGUAGE=en-us:${this.subject}`,
      `TRANSP:OPAQUE`,
      `UID:${this.to.email + this.subject}@yourapp.com123123`,
      `X-ALT-DESC;FMTTYPE=text/html:${this.htmlContent}`,
      `X-MICROSOFT-CDO-BUSYSTATUS:BUSY`,
      `X-MICROSOFT-CDO-IMPORTANCE:1`,
      `X-MICROSOFT-DISALLOW-COUNTER:FALSE`,
      `X-MS-OLK-AUTOFILLLOCATION:TRUE`,
      `X-MS-OLK-CONFTYPE:0`,
      `BEGIN:VALARM`,
      `TRIGGER:-PT15M`,
      `ACTION:DISPLAY`,
      `DESCRIPTION:Reminder`,
      `END:VALARM`,
      `END:VEVENT`,
      `END:VCALENDAR`,
    ].join('\r\n');
  }

  public createMessage() {
    const blob = new Blob([this.generateICSData()], { type: 'text/calendar; charset=utf-8' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = this.subject;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
